wbApp.directive('wbToastUiEditor', ['$window', '$timeout', 'languageService',
    function ($window, $timeout, languageService) {
        let currentLangKey = languageService.currentLangKey();
    

        function isHtml(input) {
            //console.error(input);
            return /<[a-z]+\d?(\s+[\w-]+=("[^"]*"|'[^']*'))*\s*\/?>|&#?\w+;/i.test(input);
        }

        // issue: https://github.com/nhn/tui.editor/issues/485
        // <br> to \
        function transformMarkdownOut(input) {
            return  input.replace(/<br>/g, "\\"); //.replace(/<br>/g, "\\\n");
        }

        // issue: https://github.com/nhn/tui.editor/issues/485
        // \ to <br>
        function transformMarkdownIn(input) {
            return input.replace(/\\\n/g, "<br>\n");
        }
        
        return {
            restrict: 'A',
            require: 'ngModel',
            scope: {
                status: '=ngModel',
                height: '=ngHeight',
            },
            replace: true,
            template: '<div class="wb-toast-ui-editor"></div>',
            link: function (scope, element, attrs, ctrl) {
                $timeout(function () {
                    const editor = new toastui.Editor({
                        el: element[0], 
                        height: scope.height || '300px',
                        initialValue: transformMarkdownIn(ctrl.$viewValue || ''),
                        hideModeSwitch: false,
                        initialEditType: 'wysiwyg',
                        language: currentLangKey,
                        events: {
                            change: function(data) {
                                let markDown = transformMarkdownOut(editor.getMarkdown());
                                //console.error(markDown);
                                ctrl.$setViewValue(markDown);
                            }
                        },
                        // hooks: {
                        //     addImageBlobHook(imgeBlob, callback) {
                        //     }
                        // },                        
                        toolbarItems: [
                            ['heading', 'bold', 'italic', 'strike'],
                            ['hr', 'quote'],
                            ['ul', 'ol', 'task', 'indent', 'outdent'],
                            ['table', 'link'],
                            ['code', 'codeblock'],
                            ['scrollSync'],
                        ],                        
                    });
                    editor.removeHook('addImageBlobHook');

                    ctrl.$render = function () {
                        if (isHtml(ctrl.$viewValue)) {
                            editor.setHTML(ctrl.$viewValue);
                        } else {
                            editor.setMarkdown(transformMarkdownIn(ctrl.$viewValue));
                        }
                    }
                });
            }
        }
    }]);